var _rect, _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgToastLogo = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "url(#paint0_linear_195_2417)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 15.9998C24 15.3543 23.9255 14.7272 23.7855 14.125L22.6805 14.7396C22.7549 15.1473 22.7937 15.5675 22.7937 15.9998C22.7937 19.728 19.8808 22.7489 16.2859 22.7489V23.9998C20.545 23.9998 24 20.4199 24 15.9998Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1563 15.9847C22.1563 15.6326 22.1265 15.2897 22.0699 14.9561L21.0133 15.2534C21.046 15.4944 21.064 15.7385 21.064 15.9885C21.064 18.7901 18.6933 21.0934 16.283 21.0934V21.9954C19.5264 21.9954 22.1563 19.3051 22.1563 15.9847Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4 13.5198L21.3611 12.9635C20.3425 11.1751 18.4512 9.97363 16.283 9.97363V11.0131C17.7333 11.0131 19.68 12.1066 20.4 13.5198Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3626 10.0479L19.9583 8.96677C18.8652 8.34905 17.6143 8 16.2859 8V9.24788C17.3999 9.24788 18.4453 9.53822 19.3626 10.0479Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7141 24V21.0903C13.3333 21.0903 10.9333 18.8108 10.9333 16C10.9333 13.1892 13.4133 11.0133 15.7067 11.0133V8C11.4475 8 8 11.5799 8 16C8 20.4201 11.4519 24 15.7141 24Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_195_2417",
    x1: 0,
    y1: 16,
    x2: 32,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C689C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#193E6D"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgToastLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/toast-logo.aa166f3e.svg";
export { ForwardRef as ReactComponent };